export default "__VITE_ASSET__BfQ6_kaH__"